import React, { useEffect, useRef, useState } from 'react'
import DisplaysInfo from './__info/displays__info'
import DeviceSettings from 'blocks.app/deviceSettings/deviceSettings'
import DisplaysNotifications from './__notifications/displays__notifications'
import WakeOnLan from './__wakeOnLan/wake__on__lan'
import DisplaysDateTime from './__datetime/displays__datetime'
import DisplaysPermissions from './__permissions/displays__permissions'
import DisplaysApprove from './__approve/displays__approve'
import DisplaysAdd from './__add/displays__add'
import DisplaysAddGroup from './__addGroup/displays__addGroup'
import { DisplayAudioControll } from './_blocks/displayAudioControll'
import { DisplayPlayAudioControll } from './_blocks/displayPlayAudioControll'
import { api } from 'core/api/ConnectionManager'
import helpers from 'core/helpers'
import helpersDigitalSignages from 'core/helpers/_digitalSignages'
import { getURLSearchParamsByLocation } from 'features/routes/utils'
import { routes } from 'features/routes'
import displaysHelpers from 'core/helpers/_digitalSignages'
import { InstalledApplicationList } from './organisms/InstalledApplicationList'
import toolbar from './__toolbar/displays__toolbar.methods'
import { DownloadProgressList } from './organisms/DownloadProgressList'
import { ISelectedInfo } from './__info/displays__info.local.methods'
import { ISelectedItems } from './__toolbarContent/displays__toolbarContent'
import { IUser, IUserTokens } from '../../core/models/Users'
import { DisplaysSynchronization } from './__synchronization/displays__synchronization'
import { DisplayRemoteControl } from './__remoteControl/display__remoteControl'
import { DSChangeServer } from './__changeServer/display__changeServer'
import { appActions } from 'blocks.app/app/app.state'
import store from 'core/store'
import { AddLicenses } from './__addLicenses/displays__addLicenses'
import DisplaysUploadLogs from './__uploadLogs/displays__uploadLogs'
import { P2PDownloadScheme } from './__p2pDownloadScheme/p2pDownloadScheme'
import { TagsOnGroup } from './__tagsOnGroup/TagsOnGroup'
import { IpTvSwitchChannel } from './__ipTvSwitchChannel/IpTvSwitchChannel'

export interface IDisplaysProps {
    selectedInfo: ISelectedInfo
    closeModal: () => void
    location: any
    modalState: string
    modalOptions: any
    isConnected: boolean
    downloadLogsLink: (data: { fileUrl: string }) => void
    tags: { id: number }[]
    setTags: any
    clearState: () => void
    openApprove: (value: string) => void
    setGroups: any
    clearMap: () => void
    getDisplaysWithoutAddress: () => void
    user: IUser
    windowWidth: number
    className: {}
    tokens: IUserTokens
    mainUser: any
    groups: any
    isMobilePage?: boolean
    moveSettingsModal: any
    showUploadLogsModal: boolean
}

const ModalPlaceholder = ({ close }: { close: () => void }) => {
    close()

    return null
}

let modalOptions: {
    mod: string
    showCloseIcon: boolean
    test?: boolean
    closeIconStyles?: {}
    style?: {}
} = {
    mod: '',
    showCloseIcon: true,
}

const DisplaysMethods = (p_: IDisplaysProps) => {
    const [state, setState] = useState<{
        selectedInfo: ISelectedInfo | null
        selectedItems: ISelectedItems[]
    }>({
        selectedInfo: null,
        selectedItems: [],
    })
    const tagsRef = useRef(p_.tags)

    tagsRef.current = p_.tags

    const edit = toolbar().edit

    const closeModalContent = () => {
        const { closeModal } = p_

        closeModal()
    }

    const renderModalContent = () => {
        const query = getURLSearchParamsByLocation(p_.location)

        if (p_.modalState === null) {
            modalOptions = {
                mod: 'white',
                showCloseIcon: true,
                closeIconStyles: !helpers.isMobileDevice()
                    ? {
                          top: '92px',
                      }
                    : {
                          display: 'none',
                      },
            }
        }
        if (p_.modalState === 'changeServer') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }
        if (p_.modalState === 'wakeOnLan' || p_.modalState === 'setGroupTags') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }
        if (p_.modalState === 'remoteDeviceControl') {
            modalOptions = {
                mod: 'black',
                showCloseIcon: false,
                closeIconStyles: !helpers.isMobileDevice()
                    ? {
                          top: '92px',
                      }
                    : {
                          display: 'none',
                      },
            }
        }

        if (p_.modalState === 'displayInstalledApplicationList') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }

        if (p_.modalState === 'setLicense') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }

        if (p_.modalState === 'uploadLogs') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }

        if (p_.modalState === 'switchIpTvChannel') {
            modalOptions = {
                mod: 'clear',
                showCloseIcon: false,
            }
        }

        if (p_.modalState === 'p2pDownloads') {
            modalOptions = {
                mod: 'white',
                showCloseIcon: true,
            }
        }

        if (p_.modalState === 'dateTimeDisplay') {
            modalOptions = {
                mod: 'black',
                showCloseIcon: false,
            }
        }

        switch (p_.modalState) {
            case 'approve':
                return <DisplaysApprove />
            case 'add':
                // @ts-ignore
                return <DisplaysAdd licenseId={p_.modalOptions.licenseId} />
            case 'addGroup':
                return <DisplaysAddGroup />
            case 'setLicense':
                return <AddLicenses onClose={p_.closeModal} selectedItems={state.selectedItems} />
            case 'infoDisplay':
                // @ts-ignore
                return <DisplaysInfo groups={p_.groups} query={query} selectedInfo={state.selectedInfo} />
            case 'displaySettings':
                return (
                    <DeviceSettings
                        {...state.selectedInfo}
                        options={p_.modalOptions}
                        onClose={function () {
                            p_.closeModal()
                        }}
                    />
                )
            case 'displayNotification':
                return <DisplaysNotifications selectedInfo={state.selectedInfo} />
            case 'wakeOnLan':
                return (
                    <WakeOnLan
                        digitalSignageId={state.selectedInfo && state.selectedInfo.id ? state.selectedInfo.id : null}
                        onClose={p_.closeModal}
                    />
                )
            case 'dateTimeDisplay':
                return (
                    <DisplaysDateTime
                        selectedItems={state.selectedInfo ? [state.selectedInfo] : state.selectedItems}
                        afterAction={() => {
                            setState((prevState) => {
                                return {
                                    ...prevState,
                                    selectedItems: [],
                                }
                            })
                        }}
                    />
                )
            case 'switchIpTvChannel':
                return (
                    <IpTvSwitchChannel
                        selectedItems={state.selectedInfo ? [state.selectedInfo] : state.selectedItems}
                        onClose={function () {
                            p_.closeModal()
                        }}
                    />
                )
            case 'permissions':
                return <DisplaysPermissions selectedInfo={state.selectedInfo} />
            case 'displayAudioControll':
                return <DisplayAudioControll selectedInfo={state.selectedInfo} closeModalContent={closeModalContent} />
            case 'displayPlayAudioControll':
                return (
                    <DisplayPlayAudioControll selectedInfo={state.selectedInfo} closeModalContent={closeModalContent} />
                )
            case 'displayInstalledApplicationList':
                return <InstalledApplicationList device={state.selectedInfo} />
            case 'downloadContent':
                return state.selectedInfo ? (
                    <DownloadProgressList digitalSignageId={state.selectedInfo.id && state.selectedInfo.id} />
                ) : null
            case 'displaysSynchronization':
                return state.selectedInfo ? (
                    <DisplaysSynchronization selectedInfo={state.selectedInfo} />
                ) : (
                    <ModalPlaceholder close={p_.closeModal} />
                )
            case 'remoteDeviceControl':
                return <DisplayRemoteControl device={state.selectedInfo} onClose={p_.closeModal} />
            case 'changeServer':
                return (
                    <DSChangeServer
                        device={state.selectedInfo}
                        onClose={function () {
                            p_.closeModal()
                        }}
                    />
                )
            case 'uploadLogs':
                return (
                    <DisplaysUploadLogs
                        selectedInfo={!!state.selectedItems.length ? state.selectedItems : state.selectedInfo}
                        onClose={p_.closeModal}
                    />
                )
            case 'setGroupTags':
                return <TagsOnGroup onClose={p_.closeModal} selectedInfo={state.selectedInfo} />
            case 'p2pDownloads':
                return <P2PDownloadScheme p_={state.selectedInfo} />
            default:
                return null
        }
    }

    const onGetClientLogs = (res: any) => {
        const { isConnected, downloadLogsLink } = p_

        if (isConnected) {
            downloadLogsLink(res)
        }
    }

    const onDsTagCreated = (res: any) => {
        const tags = [...tagsRef.current, res]

        tagsRef.current = tags
        p_.setTags(tags)
    }

    const onDsTagUpdated = (res: any) => {
        const tags = tagsRef.current.map((tag) => {
            if (tag.id === res.id) {
                return res
            }

            return tag
        })

        tagsRef.current = tags
        p_.setTags(tags)
    }

    const onDsTagDeleted = (res: any) => {
        const tags = tagsRef.current.filter((tag) => tag.id !== res.id)

        tagsRef.current = tags
        p_.setTags(tags)
    }

    useEffect(() => {
        const listenersId: string[] = []

        checkDisplayAddCode()

        if (helpers.isAvailable({ key: 'digitalSignage', action: 'read' })) {
            api.addObserver('dsTagCreated', onDsTagCreated, listenersId)
            api.addObserver('dsTagUpdated', onDsTagUpdated, listenersId)
            api.addObserver('dsTagDeleted', onDsTagDeleted, listenersId)
        }

        api.addObserver('getClientLogs', onGetClientLogs, listenersId)

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
            p_.clearState()
        }
    }, [])

    const checkDisplayAddCode = () => {
        const { location } = p_

        const query = getURLSearchParamsByLocation(location)
        const displayAddCode = query[`${routes.addDisplay.prefix}_code`]

        if (!displayAddCode) return

        openApproveDisplayModal(displayAddCode)
    }
    const openApproveDisplayModal = (displayAddCode: string) => {
        const { openApprove } = p_
        const isValidApproveToken = displaysHelpers.isValidApproveToken(displayAddCode)
        const approveToken = isValidApproveToken ? displaysHelpers.getApproveTokenWithMask(displayAddCode) : ''

        openApprove(approveToken)
    }

    const onGetFoldersOnMultiple = () => {
        const { setGroups } = p_
        const digitalSignageId: number[] = []
        const groupId: number[] = []

        state.selectedItems.forEach((selectedItem: ISelectedItems) => {
            if (helpersDigitalSignages.isFolder(selectedItem)) {
                groupId.push(selectedItem.id)
                return
            }

            digitalSignageId.push(selectedItem.id)
        })

        api.send('getAvailableParentGroups', { digitalSignageId, groupId, nestedQ: false }, { hideLoader: true }).then(
            (availableGroups: any) => {
                const groups = helpers.addParentKeyIdForTree(availableGroups, 'parentId')
                setGroups(groups)
            }
        )
    }
    const onSelectInfo = (selectedInfo: ISelectedInfo) => {
        const { setGroups } = p_
        setState((prevState) => {
            return {
                ...prevState,
                selectedInfo,
            }
        })

        if (selectedInfo) {
            const isDirectory = selectedInfo.type === 'group'
            let params: {
                digitalSignageId?: number[]
                groupId?: number[]
            } = {
                digitalSignageId: [selectedInfo.id],
            }
            if (isDirectory) {
                params = {
                    groupId: [selectedInfo.id],
                }
            }
            api.send('getAvailableParentGroups', { ...params, nestedQ: false }, { hideLoader: true }).then(
                (availableFolders: any) => {
                    const groups = helpers.addParentKeyIdForTree(availableFolders, 'parentId')
                    setGroups(groups)
                }
            )
        }
    }

    const onMapUnselect = () => {
        const { clearMap } = p_

        clearMap()
    }

    const onDoubleClickObject = (display: ISelectedInfo) => {
        if (
            helpers.isAvailableAction(display, {
                key: 'digitalSignage',
                action: 'update',
                subaction: 'generalEditing',
            })
        ) {
            edit(display)
        }
    }

    const mapSelect = () => {
        const { getDisplaysWithoutAddress } = p_

        getDisplaysWithoutAddress()
    }

    const onCatalogChange = () => {
        const { getDisplaysWithoutAddress } = p_
        const disposition = getDisposition()

        if (disposition !== 'map') return

        getDisplaysWithoutAddress()
    }

    const onGetTags = (tags: { id: number }[]) => {
        const { setTags } = p_

        setTags(tags)
    }

    const onSelect = (selectedItems: ISelectedItems) => {
        setState((prevState: any) => {
            return {
                ...prevState,
                selectedItems,
            }
        })
    }

    const getDisposition = () => {
        const { user } = p_
        const viewParams = helpers.getViewParamsByUser('digitalSignage', user)

        return viewParams.disposition
    }

    const onSelectItems = (selectedItems: ISelectedItems) => {
        setState((prevState: any) => {
            return {
                ...prevState,
                selectedItems,
            }
        })
    }

    const onCloseMoveSettings = () => {
        store.dispatch(appActions.closeMoveSettingsModal)
    }

    return {
        state,
        setState,
        onSelectInfo,
        getDisposition,
        onSelectItems,
        onGetFoldersOnMultiple,
        onSelect,
        onGetTags,
        mapSelect,
        onCatalogChange,
        onDoubleClickObject,
        modalOptions,
        onMapUnselect,
        renderModalContent,
        onCloseMoveSettings,
    }
}

export default DisplaysMethods
